import AbsSection from './AbsSection';
export default class SecTop extends AbsSection {
    constructor(_container='', _dataM={}, _option={}){
        super(_container, _dataM, _option, 'popular');

        if( this.isShow ) {
            $(_container + ' .title-link').prepend(_option.title);
            if( this.useManualData ){
                // this.dataM.addManual(this.alias, this.com.ip + '_mainOnOff');
                this.dataM.addCall(this.alias, {path: "/v1/videos/main?" + $.param({videoIds: _option.manualDataIds.join()})});
            } else {
                this.dataM.addCall(this.alias, {path: "/v1/videos/popular/random?" + $.param({game: this.com.ip})});
            }
        }
    }

    setTemplate(){
        let cardData = this.dataM.data.popular;
        if(typeof cardData === 'string'){
            // console.log(cardData);
            $(this.container).hide();
            return false;
        }

        let list = cardData.map( (item, idx) => {
            if(idx >= 12) return '';
            return this.cardItemTmpl(item, this.alias, 'B');
        } ).join('');

        $( this.container + ' .main-section-body .main-top-list' ).html( list );
        $( this.container + ' .paging .paging-count' ).html( `<em class="is-active">1</em> / 3` );

        this.sl = $(this.container + ' .main-top-list').slick({
            dots: false, arrows: true, infinite: false,
            speed: 600, slidesToShow: 4, slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 960,
                    settings: "unslick"
                }
            ]
        });

        this.sl.on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
            $( this.container + ' .paging .paging-count .is-active' ).html( Math.ceil((nextSlide+1)/4) );
        });


    }


} // end of class
